import * as React from 'react';
import {connect} from "react-redux";
import {createRouteNodeSelector} from "redux-router5";
import SalesTotalsFilter from "~/apps/pos/admin/components/sales/SalesTotalsFilter";
import {parseSaleFilter, saleFilterParams} from "~/apps/pos/shared/services/qsfilter";
import {getSalesTotals} from "~/apps/pos/shared/actions/sales";
import {format, startOfDay, isBefore, isEqual, addDays, parse as parseDate} from "date-fns";
import {navigate} from '~/router';
import {useCallback, useEffect, useMemo, useState} from "react";
import {Features} from "~/apps/shared/consts";


const SalesTotals = (props) => {
  const {route: {params}, dispatch, salesTotals, features} = props;
  const dateTimeFormat = "YYYY-MM-DD";

  const hasShowSalesTotalsFeature = features.includes(Features.SHOW_COMPLETED_SALES_TOTALS);
  if (!hasShowSalesTotalsFeature) {
    return null;
  }

  const filters = useMemo(() => {
    return parseSaleFilter(params);
  }, [params]);

  const [salesTotalsStartDate, setSalesTotalsStartDate] = useState((!!filters.startDt && parseDate(filters.startDt)) || addDays(startOfDay(Date.now()), -30));
  const [salesTotalsEndDate, setSalesTotalsEndDate] = useState((!!filters.endDt && parseDate(filters.endDt)) || startOfDay(Date.now()));

  useEffect(() => {
    filters.startDt = format(salesTotalsStartDate, dateTimeFormat);
    filters.endDt = format(salesTotalsEndDate, dateTimeFormat);

    navigate('pos.admin.sales', saleFilterParams(filters));
  }, [salesTotalsStartDate, salesTotalsEndDate]);

  const onFetchTotals = useCallback(() => {
    dispatch(getSalesTotals({
      ...filters,
      startDt: format(salesTotalsStartDate, dateTimeFormat),
      endDt: format(salesTotalsEndDate, dateTimeFormat)
    }));
  }, [salesTotalsStartDate, salesTotalsEndDate, filters]);

  useEffect(() => {
    onFetchTotals();
  }, [salesTotalsStartDate, salesTotalsEndDate, filters]);

  const onSalesTotalsStartDate = useCallback((dt) => {
    const date = startOfDay(dt);
    const now = startOfDay(Date.now());

    if ((isBefore(date, salesTotalsEndDate) || isEqual(date, salesTotalsEndDate)) &&
      (isBefore(date, now) || isEqual(date, now))) {
      setSalesTotalsStartDate(date);
    }
  }, [salesTotalsStartDate, salesTotalsEndDate]);

  const onSalesTotalsEndDate = useCallback((dt) => {
    const date = startOfDay(dt);
    const now = startOfDay(Date.now());

    if ((isBefore(salesTotalsStartDate, date) || isEqual(salesTotalsStartDate, date)) &&
      (isBefore(date, now) || isEqual(date, now))) {
      setSalesTotalsEndDate(date);
    }
  }, [salesTotalsStartDate, salesTotalsEndDate]);

  return (
    <SalesTotalsFilter
      initialValues={{startDate: salesTotalsStartDate, endDate: salesTotalsEndDate}}
      salesTotals={salesTotals}
      onStartDate={onSalesTotalsStartDate}
      onEndDate={onSalesTotalsEndDate}
    />
  );
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin');

  return {
    salesTotals: state.pos.salesTotals.ui.data,
    features: state.shared.information.entities.features,
    ...selector(state)
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesTotals);
